(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[151],{

/***/ 83915:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/fire-own.efe23846.svg","height":100,"width":100});

/***/ }),

/***/ 71637:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const colors = {
    blue400: "#60a5fa",
    cloudyblue: "#aaaad2",
    /** @deprecated use blue400 instead. */ drop: "#5dadec",
    fireHighlight: "#ffcc4d",
    /** @deprecated use orange400 instead. */ fireOrange: "#f4900c",
    orange400: "#fb923c",
    red400: "#F87171",
    slateus100: "#dee2f1",
    slateus200: "#b5bddb",
    slateus400: "#8991ad",
    slateus450: "#8888af",
    slateus500: "#464b6f",
    slateus600: "#2d344a",
    slateus700: "#1b2236",
    slateus800: "#131827",
    white: "#ffffff"
};
/* harmony default export */ __webpack_exports__["Z"] = (colors);


/***/ }),

/***/ 82770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _TextsNext_BodyText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68539);
/* harmony import */ var _Twemoji__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63365);
/* harmony import */ var _Accordion_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69864);
/* harmony import */ var _Accordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_4__);





const Accordion = (param)=>{
    let { title , text  } = param;
    const [isOpen, setOpen] = react__WEBPACK_IMPORTED_MODULE_1__.useState(false);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_TextsNext_BodyText__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: (_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title), " break-words py-6 text-lg ").concat(isOpen ? "".concat((_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default().open)) : ""),
                onClick: ()=>setOpen(!isOpen),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Twemoji__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    imageClassName: "inline h-6 ml-1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        dangerouslySetInnerHTML: {
                            __html: String(title)
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "whitespace-pre-line break-words pb-6 ".concat((_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default().item), " ").concat(isOpen ? "".concat((_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default().animateIn)) : "".concat((_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default().collapsed), " ").concat((_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default().animateOut))),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Twemoji__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    imageClassName: "inline h-6",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "".concat((_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default().content), " pb-6 leading-relaxed"),
                        dangerouslySetInnerHTML: {
                            __html: String(text)
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Accordion);


/***/ }),

/***/ 94191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _feature_flags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58739);
/* harmony import */ var _hooks_use_admin_token__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11331);
/* harmony import */ var _Texts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90917);
/* harmony import */ var _ToggleSwitch__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71122);
/* harmony import */ var _WidgetSubcomponents__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69443);








const AdminTools = (param)=>{
    let { setFlag  } = param;
    const adminToken = (0,_hooks_use_admin_token__WEBPACK_IMPORTED_MODULE_3__/* .useAdminToken */ .F)();
    const [minimized, setMinimized] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const featureFlags = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_feature_flags__WEBPACK_IMPORTED_MODULE_2__/* .FeatureFlagsContext */ .JN);
    const handleMinimize = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        setMinimized((minimized)=>!minimized);
    }, []);
    if (adminToken === undefined) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "\n        fixed bottom-4 left-4\n        z-20 rounded-lg\n        border-2 border-slate-600\n        bg-slateus-700 p-4\n        transition-transform\n        ".concat(minimized ? "translate-y-[88%]" : "", "\n      "),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_WidgetSubcomponents__WEBPACK_IMPORTED_MODULE_6__/* .WidgetTitle */ .P, {
                        children: "feature flags"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        onClick: handleMinimize,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Texts__WEBPACK_IMPORTED_MODULE_4__/* .BaseText */ .k$, {
                                font: "font-roboto",
                                className: "px-2 text-xl ".concat(minimized ? "hidden" : ""),
                                children: "↓"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Texts__WEBPACK_IMPORTED_MODULE_4__/* .BaseText */ .k$, {
                                font: "font-roboto",
                                className: "px-2 text-xl ".concat(minimized ? "" : "hidden"),
                                children: "↑"
                            })
                        ]
                    })
                ]
            }),
            _feature_flags__WEBPACK_IMPORTED_MODULE_2__/* .flags.map */ .id.map((flag)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex gap-x-4 justify-between items-center mt-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "mr-4 text-white",
                            children: _feature_flags__WEBPACK_IMPORTED_MODULE_2__/* .displayFlagMap */ .m2[flag]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ToggleSwitch__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            checked: featureFlags[flag],
                            onToggle: (enabled)=>setFlag({
                                    flag,
                                    enabled
                                })
                        })
                    ]
                }, flag))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AdminTools);


/***/ }),

/***/ 46756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24975);


const Fallback = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex flex-col justify-center text-slateus-400",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "m-16 mx-auto w-5/6 rounded-lg border border-red-400 bg-slateus-700 p-8 text-center font-roboto text-base font-light text-white",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mb-4",
                    children: "An exception has occured \uD83D\uDE31"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "mb-2",
                    children: [
                        "We're sorry, this should never happen! If you've seen this before, or reloading doesn't fix it, you can help debug it by sending a screenshot to",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "ml-2 cursor-pointer text-slateus-200 underline active:brightness-90",
                            href: "https://twitter.com/ultrasoundmoney/",
                            rel: "noreferrer",
                            target: "_blank",
                            children: "@ultrasoundmoney"
                        }),
                        "."
                    ]
                })
            ]
        })
    });
// Used for larger section of our app. Prefer smaller boundaries that make it
// obvious which part of the app crashed and let the rest functions as intended
// until the user fixes with a reload, or we fix with a deploy.
const BasicErrorBoundary = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__/* .ErrorBoundary */ .SV, {
        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Fallback, {}),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BasicErrorBoundary);


/***/ }),

/***/ 39469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const DefaultLink = (param)=>/*#__PURE__*/ {
    let { children , className ="" , href , onMouseEnter , onMouseLeave  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        className: "\n      ".concat(href !== undefined ? "active:brightness-75" : "", "\n      ").concat(href !== undefined ? "hover:brightness-[85%]" : "", "\n      ").concat(className, "\n    "),
        href: href,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        rel: "noreferrer",
        target: "_blank",
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DefaultLink);


/***/ }),

/***/ 62290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ WhiteEmoji; }
});

// UNUSED EXPORTS: ColoredEmoji

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
;// CONCATENATED MODULE: ./src/components/Emoji/svg-white/link.svg
/* harmony default export */ var svg_white_link = ({"src":"/_next/static/media/link.bd8ddac7.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/components/Emoji/svg-white/anchor.svg
/* harmony default export */ var svg_white_anchor = ({"src":"/_next/static/media/anchor.ccdb43ba.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/components/Emoji/svg/white-check.svg
/* harmony default export */ var white_check = ({"src":"/_next/static/media/white-check.b58a0631.svg","height":21,"width":21});
;// CONCATENATED MODULE: ./src/components/Emoji/svg/see-no-evil.svg
/* harmony default export */ var see_no_evil = ({"src":"/_next/static/media/see-no-evil.1d70890b.svg","height":21,"width":21});
;// CONCATENATED MODULE: ./src/components/Emoji/svg/hear-no-evil.svg
/* harmony default export */ var hear_no_evil = ({"src":"/_next/static/media/hear-no-evil.119180ab.svg","height":21,"width":21});
;// CONCATENATED MODULE: ./src/components/Emoji/svg/speak-no-evil.svg
/* harmony default export */ var speak_no_evil = ({"src":"/_next/static/media/speak-no-evil.548dbc46.svg","height":21,"width":21});
;// CONCATENATED MODULE: ./src/components/Emoji/index.tsx








const coloredMap = {
    "hear-no-evil": hear_no_evil,
    "see-no-evil": see_no_evil,
    "speak-no-evil": speak_no_evil,
    "white-check": white_check
};
const whiteMap = {
    anchor: svg_white_anchor,
    link: svg_white_link
};
const WhiteEmoji = (param)=>/*#__PURE__*/ {
    let { alt , className ="" , layout , name , width  } = param;
    return (0,jsx_runtime.jsx)("span", {
        className: "flex select-none ".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            alt: alt,
            layout: layout,
            src: whiteMap[name],
            height: width,
            width: width
        })
    });
};
const ColoredEmoji = (param)=>/*#__PURE__*/ {
    let { alt , layout , name , width  } = param;
    return _jsx(Image, {
        alt: alt,
        layout: layout,
        src: coloredMap[name],
        width: width
    });
};


/***/ }),

/***/ 42857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_HeaderGlow; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
;// CONCATENATED MODULE: ./src/components/HeaderGlow/header-glow.svg
/* harmony default export */ var header_glow = ({"src":"/_next/static/media/header-glow.b44ff869.svg","height":1276,"width":1079});
;// CONCATENATED MODULE: ./src/components/HeaderGlow/index.tsx



const HeaderGlow = (param)=>/*#__PURE__*/ {
    let { className  } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: "\n      absolute top-0 left-0 -z-10\n      flex\n      h-[500px]\n      w-full\n      justify-center\n      overflow-hidden\n      xs:h-[650px]\n      md:h-[700px] lg:h-[800px] xl:h-[900px]\n      2xl:h-[1200px]\n      ".concat(className, "\n    "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "\n        absolute\n        -top-[120px]\n        h-full\n        w-full\n        select-none\n        xs:-top-[180px]\n        sm:-top-[200px]\n        md:-top-[240px]\n        lg:-top-[280px]\n        xl:-top-[320px]\n        2xl:-top-[440px]\n      ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                className: "object-cover sm:object-scale-down",
                alt: "",
                src: header_glow,
                layout: "fill",
                priority: true,
                quality: 100
            })
        })
    });
};
/* harmony default export */ var components_HeaderGlow = (HeaderGlow);


/***/ }),

/***/ 6523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23375);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_1__);


const MainTitle = (param)=>/*#__PURE__*/ {
    let { children , className , onClick  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        onClick: onClick,
        className: "\n      mx-auto\n      mt-16\n      bg-transparent\n      px-4 text-center\n      text-[4.6rem] font-extralight leading-[5.4rem]\n      text-white\n      md:px-16\n      md:text-[4.0rem]\n      md:leading-[5.4rem]\n      lg:text-[4.8rem]\n      ".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_1___default().gradientText), "\n      ").concat(className, "\n    "),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MainTitle);


/***/ }),

/***/ 33040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24975);
/* harmony import */ var _Emoji__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62290);



const ConditionalLink = (param)=>{
    let { className ="" , link , children  } = param;
    return link === undefined ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        children: children
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        className: "\n        hover:brightness-90 active:brightness-75\n        ".concat(className, "\n      "),
        href: link,
        rel: "noreferrer",
        children: children
    });
};
const Title = (param)=>/*#__PURE__*/ {
    let { highlightGradient ="bg-gradient-to-tr from-gray-800 to-pink-400" , highlightPhrase , link , title  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ConditionalLink, {
        className: "flex items-center gap-x-4 text-white",
        link: link === undefined ? undefined : "#".concat(link),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                className: "\n        flex\n        text-center font-inter\n        text-2xl font-extralight text-white md:text-3xl xl:text-4xl\n      ",
                children: [
                    title,
                    highlightPhrase && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            "\xa0",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "bg-clip-text text-transparent ".concat(highlightGradient),
                                children: highlightPhrase
                            })
                        ]
                    })
                ]
            }),
            link !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-4 pt-3 md:w-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Emoji__WEBPACK_IMPORTED_MODULE_1__/* .WhiteEmoji */ .b, {
                        className: "hidden md:block",
                        alt: "emoji of a chain link symbolizing a section anchor for easy linking",
                        name: "link",
                        width: 24
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Emoji__WEBPACK_IMPORTED_MODULE_1__/* .WhiteEmoji */ .b, {
                        className: "block md:hidden",
                        alt: "emoji of a chain link symbolizing a section anchor for easy linking",
                        name: "link",
                        width: 16
                    })
                ]
            })
        ]
    });
};
const ErrorFallback = (param)=>/*#__PURE__*/ {
    let { title  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mt-32 mb-32 pt-32",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "text-center font-inter text-2xl font-extralight text-white md:text-3xl xl:text-4xl",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-col justify-center text-slateus-400",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "\n          m-16 mx-auto w-5/6 rounded-lg border border-red-400 bg-slateus-700\n          p-8 text-center font-roboto text-base font-light text-white\n        ",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mb-4",
                            children: "This section hit an exception \uD83D\uDE31"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "mb-2",
                            children: [
                                "We're sorry, this should never happen! If you've seen this before, or reloading doesn't fix it, you can help debug it by sending a screenshot to",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "ml-2 cursor-pointer text-slateus-200 underline active:brightness-90",
                                    href: "https://twitter.com/ultrasoundmoney/",
                                    rel: "noreferrer",
                                    target: "_blank",
                                    children: "@ultrasoundmoney"
                                }),
                                "."
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const Section = (param)=>/*#__PURE__*/ {
    let { children , highlightGradient ="bg-gradient-to-tr from-gray-800 to-pink-400" , highlightPhrase , link , subtitle , title  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__/* .ErrorBoundary */ .SV, {
        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ErrorFallback, {
            title: title
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            className: "mt-32 flex flex-col items-center gap-4 gap-x-4 pt-32 xs:px-4 md:px-16",
            id: link,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                    title: title,
                    link: link,
                    highlightGradient: highlightGradient,
                    highlightPhrase: highlightPhrase
                }),
                subtitle !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mt-6 text-center font-inter text-base font-light text-slateus-400 lg:text-lg",
                    children: subtitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mb-32"
                }),
                children
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Section);


/***/ }),

/***/ 90917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BY": function() { return /* binding */ LabelUnitText; },
/* harmony export */   "CK": function() { return /* binding */ TooltipTitle; },
/* harmony export */   "Z2": function() { return /* binding */ TimeFrameText; },
/* harmony export */   "f4": function() { return /* binding */ UnitText; },
/* harmony export */   "k$": function() { return /* binding */ BaseText; }
/* harmony export */ });
/* unused harmony export TextInterLink */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _TextsNext_BodyText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68539);



const LabelUnitText = (param)=>/*#__PURE__*/ {
    let { children , className =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BaseText, {
        className: "tracking-widest ".concat(className),
        color: "text-slateus-200",
        font: "font-roboto",
        size: "text-xs",
        weight: "font-light",
        children: children
    });
};
const UnitText = (param)=>/*#__PURE__*/ {
    let { className ="" , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BaseText, {
        className: className,
        color: "text-slateus-200",
        font: "font-roboto",
        weight: "font-extralight",
        children: children
    });
};
const TextInterLink = (param)=>/*#__PURE__*/ {
    let { children , className: className = ""  } = param;
    return _jsx(BodyText, {
        className: "text-slateus-200 hover:underline ".concat(className),
        children: children
    });
};
/**
 * Flexible base text component. Prefer shared text components based on it.
 */ const BaseText = (param)=>/*#__PURE__*/ {
    let { children , className ="" , color ="text-white" , font , inline =true , lineHeight ="leading-normal" , size ="" , style , tooltip , weight ="font-light"  } = param;
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(inline ? "span" : "p", {
        className: "".concat(font, " ").concat(className, " ").concat(color, " ").concat(weight, " ").concat(size, " ").concat(lineHeight),
        style: style,
        title: tooltip
    }, children);
};
const TimeFrameText = (param)=>/*#__PURE__*/ {
    let { children , className =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BaseText, {
        className: "tracking-widest ".concat(className),
        size: "text-xs",
        font: "font-roboto",
        weight: "font-normal",
        children: children
    });
};
const TooltipTitle = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BaseText, {
        font: "font-inter",
        size: "text-base md:text-lg",
        weight: "font-normal",
        children: children
    });
};


/***/ }),

/***/ 68539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Texts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90917);


/**
 * @deprecated build on BodyTextV2 instead to support smaller screens better.
 */ const BodyText = (param)=>/*#__PURE__*/ {
    let { children , className , inline  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Texts__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k$, {
        font: "font-inter",
        className: className,
        size: "text-base md:text-lg",
        inline: inline,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BodyText);


/***/ }),

/***/ 30451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Texts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90917);


const BodyTextV2 = (param)=>/*#__PURE__*/ {
    let { color , children , className , inline  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Texts__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k$, {
        className: className,
        color: color,
        font: "font-inter",
        inline: inline,
        size: "text-xs md:text-base",
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BodyTextV2);


/***/ }),

/***/ 89802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Texts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90917);


const LabelText = (param)=>/*#__PURE__*/ {
    let { children , className ="" , color ="text-slateus-200"  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Texts__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k$, {
        font: "font-inter",
        color: color,
        className: "\n      text-xs\n      uppercase tracking-widest\n      ".concat(className, "\n    "),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LabelText);


/***/ }),

/***/ 90079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Texts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90917);


const QuantifyText = (param)=>/*#__PURE__*/ {
    let { amountPostfix , children , className , color , lineHeight , size , unitPostfix , unitPostfixColor ="text-slateus-400" , unitPostfixMargin ="ml-1"  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Texts__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k$, {
        className: className,
        color: color,
        font: "font-roboto",
        lineHeight: lineHeight,
        size: size,
        children: [
            children,
            amountPostfix,
            unitPostfix && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Texts__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k$, {
                font: "font-roboto",
                color: unitPostfixColor,
                className: unitPostfixMargin,
                size: size,
                children: unitPostfix
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (QuantifyText);


/***/ }),

/***/ 44759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Emoji__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62290);


const SectionTitle = (param)=>/*#__PURE__*/ {
    let { children , className ="" , highlightGradient ="bg-gradient-to-tr from-gray-800 to-pink-400" , highlightPhrase , link , subtitle  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex items-center justify-center gap-x-4 ".concat(className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    className: "\n          flex items-center gap-x-4 text-white\n          ".concat(link === undefined ? "" : "hover:brightness-90 active:brightness-75"),
                    href: link === undefined ? undefined : "#".concat(link),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                            className: "\n                text-center font-inter\n                text-2xl font-extralight text-white md:text-3xl xl:text-4xl\n              ",
                            children: [
                                children,
                                highlightPhrase && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        "\xa0",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "bg-clip-text text-transparent ".concat(highlightGradient),
                                            children: highlightPhrase
                                        })
                                    ]
                                })
                            ]
                        }),
                        link !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-4 md:w-6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Emoji__WEBPACK_IMPORTED_MODULE_1__/* .WhiteEmoji */ .b, {
                                    className: "hidden md:block",
                                    alt: "emoji of a chain link symbolizing a section anchor for easy linking",
                                    name: "link",
                                    width: 24
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Emoji__WEBPACK_IMPORTED_MODULE_1__/* .WhiteEmoji */ .b, {
                                    className: "block md:hidden",
                                    alt: "emoji of a chain link symbolizing a section anchor for easy linking",
                                    name: "link",
                                    width: 16
                                })
                            ]
                        })
                    ]
                })
            }),
            subtitle !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "\n            mt-6 text-center\n            font-inter text-base font-light text-slateus-400\n            lg:text-lg\n          ",
                children: subtitle
            })
        ]
    });
};


/***/ }),

/***/ 7569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84849);
/* harmony import */ var _feature_flags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58739);




/**
 * SkeletonText places a skeleton while content loads. Should be put *inside*
 * text elements to automatically adopt the right size through text styling.
 */ const SkeletonText = (param)=>{
    let { children , className ="" , inline =true , width =100  } = param;
    const { previewSkeletons  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_feature_flags__WEBPACK_IMPORTED_MODULE_2__/* .FeatureFlagsContext */ .JN);
    return children === undefined || previewSkeletons ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: className,
        inline: inline,
        width: width
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkeletonText);


/***/ }),

/***/ 5429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ LondonHardForkTooltip; },
  "Z": function() { return /* binding */ components_TimeFrameControl; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./src/assets/fire-own.svg
var fire_own = __webpack_require__(83915);
;// CONCATENATED MODULE: ./src/assets/fire-slateus.svg
/* harmony default export */ var fire_slateus = ({"src":"/_next/static/media/fire-slateus.aefa304c.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/panda-own.svg
/* harmony default export */ var panda_own = ({"src":"/_next/static/media/panda-own.8181cb98.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/panda-slateus.svg
/* harmony default export */ var panda_slateus = ({"src":"/_next/static/media/panda-slateus.657029a6.svg","height":100,"width":100});
// EXTERNAL MODULE: ./src/mainsite/time-frames.ts
var time_frames = __webpack_require__(78868);
// EXTERNAL MODULE: ./src/mainsite/components/HoverTooltip.tsx
var HoverTooltip = __webpack_require__(56862);
;// CONCATENATED MODULE: ./src/components/TimeFrameControl.tsx








const Button = (param)=>/*#__PURE__*/ {
    let { children , isActive , onClick , disabled , title  } = param;
    return (0,jsx_runtime.jsx)("button", {
        className: "\n      select-none rounded-sm\n      border px-[10px] py-2\n      font-roboto \n      text-xs\n      font-normal\n      tracking-widest\n      ".concat(disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer", "\n      ").concat(isActive && !disabled ? "border-slateus-400 bg-slateus-600 text-white" : "border-transparent text-slateus-200", "\n    "),
        onClick: disabled ? undefined : onClick,
        title: title ? title : undefined,
        children: children
    });
};
const LondonHardForkTooltip = (param)=>/*#__PURE__*/ {
    let { children , timeFrame , zLevel  } = param;
    return (0,jsx_runtime.jsx)(HoverTooltip/* default */.Z, {
        customAlign: "-left-32",
        text: timeFrame === "since_burn" ? "Since-burn time frame. Starting from the london hard fork where EIP-1559 was activated." : undefined,
        zLevel: zLevel,
        children: children
    });
};
const FireImage = (param)=>/*#__PURE__*/ {
    let { selectedTimeframe  } = param;
    return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "\n        h-4 w-4\n        ".concat(selectedTimeframe === "since_burn" ? "hidden" : "block", "\n      "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: selectedTimeframe === "since_burn" ? "hidden" : "block",
                    alt: "flame emoji symbolizing time span since london hard fork when EIP-1559 was activated",
                    src: fire_slateus,
                    width: 16,
                    height: 16
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "\n        h-4 w-4\n        ".concat(selectedTimeframe === "since_burn" ? "block" : "hidden", "\n      "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: "flame emoji symbolizing time span since london hard fork when EIP-1559 was activated",
                    src: fire_own/* default */.Z,
                    width: 16,
                    height: 16
                })
            })
        ]
    });
};
const PandaImage = (param)=>/*#__PURE__*/ {
    let { selectedTimeframe  } = param;
    return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "\n        h-4 w-4\n        ".concat(selectedTimeframe === "since_merge" ? "hidden" : "block", "\n      "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: selectedTimeframe === "since_merge" ? "hidden" : "block",
                    alt: "panda emoji symbolizing the time span since the merge happened",
                    src: panda_slateus,
                    width: 16,
                    height: 16
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "\n        h-4 w-4\n        ".concat(selectedTimeframe === "since_merge" ? "block" : "hidden", "\n      "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: "panda emoji symbolizing the time span since the merge happened",
                    src: panda_own,
                    width: 16,
                    height: 16
                })
            })
        ]
    });
};
const TimeFrameControlCensorship = (param)=>/*#__PURE__*/ {
    let { selectedTimeFrame , onSetTimeFrame  } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: "flex flex-row items-center lg:gap-x-1",
        children: [
            "d1",
            "d7",
            "d30",
            "since_merge"
        ].map((timeFrame)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LondonHardForkTooltip, {
                timeFrame: timeFrame,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                    isActive: selectedTimeFrame === timeFrame,
                    onClick: ()=>onSetTimeFrame(timeFrame),
                    disabled: timeFrame === "since_merge" || timeFrame === "d1",
                    title: "coming soon",
                    children: timeFrame === "since_merge" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PandaImage, {
                        selectedTimeframe: selectedTimeFrame
                    }) : time_frames/* displayLimitedTimeFrameMap */.I1[timeFrame]
                })
            }, timeFrame))
    });
};
const TimeFrameControl = (param)=>{
    let { selectedTimeFrame: selectedTimeframe , onSetTimeFrame , version ="all"  } = param;
    return version === "censorship" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeFrameControlCensorship, {
        selectedTimeFrame: selectedTimeframe,
        onSetTimeFrame: onSetTimeFrame
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-row flex-wrap items-center lg:gap-x-1",
        children: (version === "all" ? time_frames/* timeFrames */.hN : version === "no_merge" ? time_frames/* timeFramesNoMerge */.EH : undefined).map((timeFrame)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LondonHardForkTooltip, {
                timeFrame: timeFrame,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                    isActive: selectedTimeframe === timeFrame,
                    onClick: ()=>onSetTimeFrame(timeFrame),
                    children: timeFrame === "since_merge" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PandaImage, {
                        selectedTimeframe: selectedTimeframe
                    }) : timeFrame === "since_burn" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FireImage, {
                        selectedTimeframe: selectedTimeframe
                    }) : time_frames/* displayLimitedTimeFrameMap */.I1[timeFrame]
                })
            }, timeFrame))
    });
};
/* harmony default export */ var components_TimeFrameControl = (TimeFrameControl);


/***/ }),

/***/ 71122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ToggleSwitch_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17743);
/* harmony import */ var _ToggleSwitch_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ToggleSwitch_module_scss__WEBPACK_IMPORTED_MODULE_1__);


const ToggleSwitch = (param)=>/*#__PURE__*/ {
    let { checked , className , onToggle  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
        checked: checked,
        onChange: (e)=>onToggle(e.target.checked),
        className: "".concat(className !== null && className !== void 0 ? className : "", " ").concat((_ToggleSwitch_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["toggle-switch"])),
        type: "checkbox"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ToggleSwitch);


/***/ }),

/***/ 63365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var twemoji__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45623);



const parseChild = (child, imageClassName)=>{
    twemoji__WEBPACK_IMPORTED_MODULE_2__/* ["default"].parse */ .Z.parse(child, {
        className: imageClassName,
        ext: ".svg",
        folder: "svg"
    });
};
const Twemoji = (param)=>{
    let { children , className ="" , imageClassName , wrapper =false , tag ="div"  } = param;
    const wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const refList = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)([]);
    const [replaceDone, setReplaceDone] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        refList.current.map((childRef)=>{
            parseChild(childRef, imageClassName);
        });
        setReplaceDone(true);
    }, [
        children,
        imageClassName,
        refList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (wrapperRef.current === null) {
            return;
        }
        parseChild(wrapperRef.current, imageClassName);
        setReplaceDone(true);
    }, [
        children,
        wrapperRef,
        imageClassName
    ]);
    return children == null ? null : wrapper ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(tag, {
        ref: wrapperRef,
        className: "".concat(className).concat(replaceDone ? "" : " invisible")
    }, children) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, (child, index)=>{
            if (child == null) {
                return null;
            }
            if (typeof child === "string") {
                console.warn("Twemoji can't parse plain strings, and strings are passed with wrapper set. Wrap them or add 'wrapper'");
                return child;
            }
            if (typeof child === "boolean") {
                console.warn("Twemoji can't parse plain booleans, and strings are passed with wrapper set. Wrap them or add 'wrapper'");
                return child;
            }
            if (typeof child === "number") {
                console.warn("Twemoji can't parse plain numbers, and strings are passed with wrapper set. Wrap them or add 'wrapper'");
                return child;
            }
            if (!/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(child)) {
                console.error("Twemoji can't parse invalid react element. Wrap them or add 'wrapper'");
                return child;
            }
            var _className;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(child, {
                ref: (ref)=>{
                    refList.current[index] = ref;
                },
                className: "".concat((_className = child.props.className) !== null && _className !== void 0 ? _className : "").concat(replaceDone ? "" : " invisible")
            });
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Twemoji);


/***/ }),

/***/ 46400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_WidgetErrorBoundary; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@sentry/react/esm/errorboundary.js
var errorboundary = __webpack_require__(24975);
;// CONCATENATED MODULE: ./src/components/ErrorWidget.tsx

const ErrorWidget = (param)=>/*#__PURE__*/ {
    let { title  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        className: "w-full rounded-lg border border-red-400 bg-slateus-700 p-8 font-roboto text-base font-light text-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mb-8 font-inter text-xs font-light uppercase tracking-widest text-slateus-200",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mb-4",
                children: "An exception has occured \uD83D\uDE31"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "mb-2",
                children: [
                    "We're sorry, this should never happen! If you've seen this before, or reloading doesn't fix it, you can help debug it by sending a screenshot to",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "ml-2 cursor-pointer text-slateus-200 underline active:brightness-90",
                        href: "https://twitter.com/ultrasoundmoney/",
                        rel: "noreferrer",
                        target: "_blank",
                        children: "@ultrasoundmoney"
                    }),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var components_ErrorWidget = (ErrorWidget);

;// CONCATENATED MODULE: ./src/components/WidgetErrorBoundary.tsx



const WidgetErrorBoundary = (param)=>/*#__PURE__*/ {
    let { children , title  } = param;
    return (0,jsx_runtime.jsx)(errorboundary/* ErrorBoundary */.SV, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ErrorWidget, {
            title: title
        }),
        children: children
    });
};
/* harmony default export */ var components_WidgetErrorBoundary = (WidgetErrorBoundary);


/***/ }),

/***/ 69443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ WidgetBackground; },
/* harmony export */   "P": function() { return /* binding */ WidgetTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const WidgetBackground = (param)=>/*#__PURE__*/ {
    let { children , className  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "\n      rounded-lg bg-slateus-700 p-8\n      ".concat(className !== null && className !== void 0 ? className : "", "\n    "),
        children: children
    });
};
const WidgetTitle = (param)=>/*#__PURE__*/ {
    let { className , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "\n      font-inter text-xs\n      font-light uppercase\n      tracking-widest text-slateus-200\n      ".concat(className !== null && className !== void 0 ? className : "", "\n    "),
        children: children
    });
};


/***/ }),

/***/ 20929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hh": function() { return /* binding */ getApiEnv; },
/* harmony export */   "dU": function() { return /* binding */ getEnv; },
/* harmony export */   "mp": function() { return /* binding */ getUsmDomain; }
/* harmony export */ });
/* provided dependency */ var process = __webpack_require__(83454);
const getEnv = ()=>{
    const rawEnv = process.env.NEXT_PUBLIC_ENV;
    switch(rawEnv){
        case "prod":
            return "prod";
        case "dev":
            return "dev";
        case "staging":
            return "stag";
        case "stag":
            return "stag";
        default:
            console.warn("no ENV in env, defaulting to dev");
            return "dev";
    }
};
const getApiEnv = ()=>{
    const apiEnv = process.env.NEXT_PUBLIC_API_ENV;
    // If API_ENV is undefined, we decide based on ENV
    if (apiEnv === undefined) {
        // Use production by default, unless we're running on staging, then use staging.
        return getEnv() === "stag" ? "stag" : "prod";
    }
    switch(apiEnv){
        case "dev":
            return "dev";
        case "prod":
        case "production":
            return "prod";
        case "stag":
        case "staging":
            return "stag";
        default:
            return "prod";
    }
};
const getUsmDomain = ()=>{
    const apiEnv = getApiEnv();
    switch(apiEnv){
        case "dev":
            return "http://localhost:3000";
        case "stag":
            return "https://usm-i7x0.ultrasound.money";
        case "prod":
            return "https://ultrasound.money";
    }
};


/***/ }),

/***/ 47387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ NavigationContext; }
/* harmony export */ });
/* unused harmony export NavigationProvider */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const defaultContext = {
    hidingNavigationPosition: 0,
    changeHidingNavigationPosition: (value)=>value,
    faqPosition: 0,
    changeFaqPosition: (value)=>value
};
const NavigationContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(defaultContext);
const NavigationProvider = (param)=>{
    let { children  } = param;
    const [hidingNavigationPosition, setHidingNavigationPosition] = useState(0);
    const [faqPosition, setFaqPosition] = useState(0);
    const changeHidingNavigationPosition = (value)=>{
        setHidingNavigationPosition(value);
    };
    const changeFaqPosition = (value)=>{
        setFaqPosition(value);
    };
    return /*#__PURE__*/ _jsx(NavigationContext.Provider, {
        value: {
            hidingNavigationPosition,
            changeHidingNavigationPosition,
            faqPosition,
            changeFaqPosition
        },
        children: children
    });
};



/***/ }),

/***/ 71119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b9": function() { return /* binding */ londonHardFork; },
/* harmony export */   "s_": function() { return /* binding */ mergeDateTime; }
/* harmony export */ });
/* unused harmony export parisHardFork */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23855);

const londonHardFork = date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z("2021-08-05T12:33:42.000Z");
const parisHardFork = date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z("2022-09-15T06:42:42Z");
const mergeDateTime = parisHardFork;


/***/ }),

/***/ 5964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Io": function() { return /* binding */ millisFromSeconds; },
/* harmony export */   "QN": function() { return /* binding */ millisFromHours; },
/* harmony export */   "kY": function() { return /* binding */ millisFromDays; },
/* harmony export */   "wb": function() { return /* binding */ millisFromMinutes; }
/* harmony export */ });
/* unused harmony exports secsFromDays, secsFromMinutes */
const millisFromSeconds = (seconds)=>seconds * 1000;
const millisFromMinutes = (minutes)=>minutes * 60 * 1000;
const millisFromHours = (hours)=>hours * 60 * 60 * 1000;
const millisFromDays = (days)=>days * 24 * 60 * 60 * 1000;
const secsFromDays = (days)=>days * 24 * 60 * 60;
const secsFromMinutes = (minutes)=>minutes * 60;


/***/ }),

/***/ 41492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Du": function() { return /* binding */ WEI_PER_ETH; },
/* harmony export */   "c1": function() { return /* binding */ WEI_PER_GWEI; },
/* harmony export */   "fk": function() { return /* binding */ WEI_PER_GWEI_JSBI; },
/* harmony export */   "rn": function() { return /* binding */ GWEI_PER_ETH; }
/* harmony export */ });
/* harmony import */ var jsbi__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39499);
/* harmony import */ var jsbi__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jsbi__WEBPACK_IMPORTED_MODULE_0__);

const WEI_PER_GWEI_JSBI = jsbi__WEBPACK_IMPORTED_MODULE_0___default().exponentiate(jsbi__WEBPACK_IMPORTED_MODULE_0___default().BigInt(10), jsbi__WEBPACK_IMPORTED_MODULE_0___default().BigInt(9));
const WEI_PER_ETH = 1e18;
const WEI_PER_GWEI = 1e9;
const GWEI_PER_ETH = 1e9;


/***/ }),

/***/ 58739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JN": function() { return /* binding */ FeatureFlagsContext; },
/* harmony export */   "gV": function() { return /* binding */ useFeatureFlags; },
/* harmony export */   "id": function() { return /* binding */ flags; },
/* harmony export */   "m2": function() { return /* binding */ displayFlagMap; }
/* harmony export */ });
/* unused harmony export defaults */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const flags = [
    "enableSupplyLegendClick",
    "previewSkeletons",
    "showCategoryCounts",
    "showCategorySlugs",
    "showMetadataTools",
    "showTooltips",
    "simulateDeflationary",
    "useWebSockets"
];
const defaults = {
    enableSupplyLegendClick: false,
    previewSkeletons: false,
    showCategoryCounts: false,
    showCategorySlugs: false,
    showMetadataTools: false,
    showTooltips: false,
    simulateDeflationary: false,
    useWebSockets: false
};
const displayFlagMap = {
    enableSupplyLegendClick: "enable supply legend click",
    previewSkeletons: "preview skeletons",
    showCategoryCounts: "show category counts",
    showCategorySlugs: "show category slugs",
    showMetadataTools: "show metadata tools",
    showTooltips: "show tooltips",
    simulateDeflationary: "simulate deflationary",
    useWebSockets: "use websockets"
};
const reducer = (state, action)=>({
        ...state,
        [action.flag]: action.enabled
    });
const useFeatureFlags = ()=>{
    const [featureFlags, setFlag] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(reducer, defaults);
    return {
        featureFlags,
        setFlag
    };
};
const FeatureFlagsContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(defaults);


/***/ }),

/***/ 12597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B_": function() { return /* binding */ formatPercentOneDecimal; },
/* harmony export */   "F9": function() { return /* binding */ formatOneDecimal; },
/* harmony export */   "Fu": function() { return /* binding */ formatPercentNoDecimals; },
/* harmony export */   "Gb": function() { return /* binding */ formatCompactOneDecimal; },
/* harmony export */   "LU": function() { return /* binding */ formatDuration; },
/* harmony export */   "UY": function() { return /* binding */ formatZeroDecimals; },
/* harmony export */   "W3": function() { return /* binding */ formatPercentOneDecimalSigned; },
/* harmony export */   "Wk": function() { return /* binding */ formatZeroDigitsSigned; },
/* harmony export */   "Xn": function() { return /* binding */ ethFromGwei; },
/* harmony export */   "Xx": function() { return /* binding */ formatPercentThreeDecimalsSigned; },
/* harmony export */   "Zb": function() { return /* binding */ gweiFromWei; },
/* harmony export */   "cI": function() { return /* binding */ formatTwoDigit; },
/* harmony export */   "cU": function() { return /* binding */ formatPercentFiveDecimalsSigned; },
/* harmony export */   "cj": function() { return /* binding */ formatDurationToNow; },
/* harmony export */   "jc": function() { return /* binding */ formatPercentTwoDecimalSigned; },
/* harmony export */   "kC": function() { return /* binding */ capitalize; },
/* harmony export */   "vJ": function() { return /* binding */ formatPercentTwoDecimals; },
/* harmony export */   "x_": function() { return /* binding */ formatBlockNumber; },
/* harmony export */   "yJ": function() { return /* binding */ formatTwoDigitsSigned; },
/* harmony export */   "yz": function() { return /* binding */ formatWeiTwoDigit; },
/* harmony export */   "zQ": function() { return /* binding */ ethFromWei; }
/* harmony export */ });
/* unused harmony exports intlFormat, formatUsdZeroDecimals, formatPercentThreeDecimals, formatPercentFourDecimalsSigned, formatCompact, ethFromWeiBIUnsafe, convertToInternationalCurrencySystem */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11699);
/* harmony import */ var jsbi__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39499);
/* harmony import */ var jsbi__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jsbi__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _eth_units__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41492);



const intlFormatter = new Intl.NumberFormat();
function intlFormat(num) {
    return intlFormatter.format(num);
}
const twoDigit = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});
const formatWeiTwoDigit = (wei)=>twoDigit.format(wei / _eth_units__WEBPACK_IMPORTED_MODULE_1__/* .WEI_PER_ETH */ .Du);
const formatTwoDigit = (num)=>twoDigit.format(num);
const twoDigitSigned = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    signDisplay: "always"
});
const formatTwoDigitsSigned = (num)=>twoDigitSigned.format(num);
const zeroDecimals = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 0
});
const zeroDigitSigned = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    signDisplay: "always"
});
const formatZeroDigitsSigned = (num)=>zeroDigitSigned.format(num);
const formatZeroDecimals = (num)=>zeroDecimals.format(num);
const oneDecimal = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
});
const formatOneDecimal = (num)=>oneDecimal.format(num);
const usdZeroDecimals = new Intl.NumberFormat("en-US", {
    currency: "usd",
    style: "currency",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});
const formatUsdZeroDecimals = (num)=>usdZeroDecimals.format(num);
const percentOneDecimalSigned = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
    signDisplay: "always",
    style: "percent"
});
const formatPercentOneDecimalSigned = (percent)=>percentOneDecimalSigned.format(percent);
const percentTwoDecimalSigned = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    signDisplay: "always",
    style: "percent"
});
const formatPercentTwoDecimalSigned = (percent)=>percentTwoDecimalSigned.format(percent);
const percentOneDecimal = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
    style: "percent"
});
const formatPercentOneDecimal = (percent)=>percentOneDecimal.format(percent);
const percentNoDecimals = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 0,
    style: "percent"
});
const formatPercentNoDecimals = (percent)=>percentNoDecimals.format(percent);
const percentTwoDecimals = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: "percent"
});
const formatPercentTwoDecimals = (fraction)=>percentTwoDecimals.format(fraction);
const percentThreeDecimals = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
    style: "percent"
});
const formatPercentThreeDecimals = (fraction)=>percentThreeDecimals.format(fraction);
const percentThreeDecimalsSigned = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
    style: "percent",
    signDisplay: "always"
});
const formatPercentThreeDecimalsSigned = (fraction)=>percentThreeDecimalsSigned.format(fraction);
const percentFourDecimalsSigned = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
    style: "percent",
    signDisplay: "always"
});
const formatPercentFourDecimalsSigned = (fraction)=>percentFourDecimalsSigned.format(fraction);
const percentFiveDecimalsSigned = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 5,
    maximumFractionDigits: 5,
    style: "percent",
    signDisplay: "always"
});
const formatPercentFiveDecimalsSigned = (fraction)=>percentFiveDecimalsSigned.format(fraction);
const compactNumber = new Intl.NumberFormat("en", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    notation: "compact"
});
const formatCompact = (num)=>compactNumber.format(num);
const compactNumberOneDecimal = new Intl.NumberFormat("en", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
    notation: "compact"
});
const formatCompactOneDecimal = (num)=>compactNumberOneDecimal.format(num);
const gweiFromWei = (wei)=>wei / _eth_units__WEBPACK_IMPORTED_MODULE_1__/* .WEI_PER_GWEI */ .c1;
const ethFromWei = (wei)=>wei / _eth_units__WEBPACK_IMPORTED_MODULE_1__/* .WEI_PER_ETH */ .Du;
const ethFromWeiBIUnsafe = (wei)=>JSBI.toNumber(JSBI.divide(wei, JSBI.exponentiate(JSBI.BigInt(10), JSBI.BigInt(18))));
const ethFromGwei = (gwei)=>gwei / _eth_units__WEBPACK_IMPORTED_MODULE_1__/* .GWEI_PER_ETH */ .rn;
function convertToInternationalCurrencySystem(labelValue) {
    // Nine Zeroes for Billions
    return Math.abs(Number(labelValue)) >= 1.0e9 ? Number(Math.abs(Number(labelValue)) / 1.0e9).toFixed(2) + "B" : Math.abs(Number(labelValue)) >= 1.0e6 ? Number(Math.abs(Number(labelValue)) / 1.0e6).toFixed(2) + "M" : Math.abs(Number(labelValue)) >= 1.0e3 ? Number(Math.abs(Number(labelValue)) / 1.0e3).toFixed(2) + "K" : Math.abs(Number(labelValue)).toFixed(2);
}
const capitalize = (str)=>{
    var ref;
    return typeof str === "string" ? "".concat((ref = str[0]) === null || ref === void 0 ? void 0 : ref.toUpperCase()).concat(str.slice(1)) : undefined;
};
const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 60 * SECONDS_PER_MINUTE;
const SECONDS_PER_DAY = 24 * SECONDS_PER_HOUR;
const SECONDS_PER_WEEK = 7 * SECONDS_PER_DAY;
/** Formats a distance in time using the smallest possible whole unit, but no smaller than seconds. */ const formatDuration = function(seconds) {
    let long = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const weeksDelta = Math.floor(seconds / SECONDS_PER_WEEK);
    if (weeksDelta > 0) {
        return long ? "".concat(weeksDelta, " weeks") : "".concat(weeksDelta, "w");
    }
    const daysDelta = Math.floor(seconds % SECONDS_PER_WEEK / SECONDS_PER_DAY);
    if (daysDelta > 0) {
        return long ? "".concat(daysDelta, " days") : "".concat(daysDelta, "d");
    }
    const hoursDelta = Math.floor(seconds % SECONDS_PER_DAY / SECONDS_PER_HOUR);
    if (hoursDelta > 0) {
        return long ? "".concat(hoursDelta, " hours") : "".concat(hoursDelta, "h");
    }
    const minutesDelta = Math.floor(seconds % SECONDS_PER_HOUR / SECONDS_PER_MINUTE);
    if (minutesDelta > 0) {
        return long ? "".concat(minutesDelta, " minutes") : "".concat(minutesDelta, "m");
    }
    return long ? "".concat(seconds.toFixed(1), " seconds") : "".concat(seconds.toFixed(1), "s");
};
const formatDurationToNow = (now, dt)=>{
    const distance = date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z(now, dt);
    return formatDuration(distance);
};
const formatBlockNumber = (number)=>typeof number === "number" ? "#".concat(formatZeroDecimals(number)) : undefined;


/***/ }),

/***/ 96019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* reexport module object */ fp_ts_lib_Array__WEBPACK_IMPORTED_MODULE_0__; },
/* harmony export */   "N": function() { return /* reexport module object */ fp_ts_lib_number__WEBPACK_IMPORTED_MODULE_1__; },
/* harmony export */   "O": function() { return /* reexport module object */ fp_ts_lib_Option__WEBPACK_IMPORTED_MODULE_2__; },
/* harmony export */   "R": function() { return /* reexport module object */ fp_ts_lib_Record__WEBPACK_IMPORTED_MODULE_4__; },
/* harmony export */   "RA": function() { return /* reexport module object */ fp_ts_lib_ReadonlyArray__WEBPACK_IMPORTED_MODULE_5__; },
/* harmony export */   "gt": function() { return /* reexport module object */ fp_ts_lib_Ord__WEBPACK_IMPORTED_MODULE_3__; },
/* harmony export */   "ls": function() { return /* reexport safe */ fp_ts_lib_function__WEBPACK_IMPORTED_MODULE_6__.flow; },
/* harmony export */   "n": function() { return /* binding */ OAlt; },
/* harmony export */   "zG": function() { return /* reexport safe */ fp_ts_lib_function__WEBPACK_IMPORTED_MODULE_6__.pipe; }
/* harmony export */ });
/* unused harmony exports TAlt, TEAlt, MapFS, EAlt */
/* harmony import */ var fp_ts_lib_Array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23258);
/* harmony import */ var fp_ts_lib_Array__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fp_ts_lib_Array__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var fp_ts_lib_number__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59093);
/* harmony import */ var fp_ts_lib_Option__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57967);
/* harmony import */ var fp_ts_lib_Option__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(fp_ts_lib_Option__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var fp_ts_lib_Ord__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88073);
/* harmony import */ var fp_ts_lib_Record__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91891);
/* harmony import */ var fp_ts_lib_Record__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(fp_ts_lib_Record__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var fp_ts_lib_ReadonlyArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84675);
/* harmony import */ var fp_ts_lib_ReadonlyArray__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(fp_ts_lib_ReadonlyArray__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var fp_ts_lib_function__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30902);
/* harmony import */ var fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45974);
/* harmony import */ var fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var fp_ts_lib_Map__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7989);
/* harmony import */ var fp_ts_lib_Map__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(fp_ts_lib_Map__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var fp_ts_lib_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(57018);
/* harmony import */ var fp_ts_lib_Task__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60543);
/* harmony import */ var fp_ts_lib_Task__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(fp_ts_lib_Task__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var fp_ts_lib_Apply__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11395);
/* harmony import */ var fp_ts_lib_Apply__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(fp_ts_lib_Apply__WEBPACK_IMPORTED_MODULE_7__);














































const TAlt = {
    sequenceArraySeq: (0,fp_ts_lib_Apply__WEBPACK_IMPORTED_MODULE_7__.sequenceS)(fp_ts_lib_Task__WEBPACK_IMPORTED_MODULE_8__.ApplySeq),
    sequenceStructPar: (0,fp_ts_lib_Apply__WEBPACK_IMPORTED_MODULE_7__.sequenceS)(fp_ts_lib_Task__WEBPACK_IMPORTED_MODULE_8__.ApplyPar),
    sequenceStructSeq: (0,fp_ts_lib_Apply__WEBPACK_IMPORTED_MODULE_7__.sequenceS)(fp_ts_lib_Task__WEBPACK_IMPORTED_MODULE_8__.ApplySeq),
    sequencyArrayPar: (0,fp_ts_lib_Apply__WEBPACK_IMPORTED_MODULE_7__.sequenceS)(fp_ts_lib_Task__WEBPACK_IMPORTED_MODULE_8__.ApplyPar)
};
const getIsErrorLike = (e)=>typeof e === "object" && e !== null && "error" in e;
const getIsErrorLikeB = (e)=>typeof e === "object" && e !== null && "type" in e && "message" in e;
const unwrap = (e)=>(0,fp_ts_lib_function__WEBPACK_IMPORTED_MODULE_6__.pipe)(e, fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_9__.getOrElse((e)=>{
        if (e instanceof Error) {
            throw e;
        }
        if (typeof e === "string") {
            throw new Error(e);
        }
        if (getIsErrorLike(e)) {
            throw e.error;
        }
        if (getIsErrorLikeB(e)) {
            throw new Error("".concat(e.type, ": ").concat(e.message));
        }
        throw new Error("failed to throw on getOrThrow, left is not an error and not a string");
    }));
const TEAlt = {
    unwrap: (te)=>(0,fp_ts_lib_function__WEBPACK_IMPORTED_MODULE_6__.pipe)(te, fp_ts_lib_Task__WEBPACK_IMPORTED_MODULE_8__.map((e)=>unwrap(e)))
};
const MapFS = {
    lookup: fp_ts_lib_Map__WEBPACK_IMPORTED_MODULE_10__.lookup(fp_ts_lib_string__WEBPACK_IMPORTED_MODULE_11__.Eq),
    upsertAt: fp_ts_lib_Map__WEBPACK_IMPORTED_MODULE_10__.upsertAt(fp_ts_lib_string__WEBPACK_IMPORTED_MODULE_11__.Eq)
};
const EAlt = {
    unwrap,
    sequenceArray: (0,fp_ts_lib_Apply__WEBPACK_IMPORTED_MODULE_7__.sequenceS)(fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_9__.Apply),
    sequenceStruct: (0,fp_ts_lib_Apply__WEBPACK_IMPORTED_MODULE_7__.sequenceS)(fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_9__.Apply)
};
const OAlt = {
    expect: (message)=>(o)=>(0,fp_ts_lib_function__WEBPACK_IMPORTED_MODULE_6__.pipe)(o, fp_ts_lib_Option__WEBPACK_IMPORTED_MODULE_2__.getOrElse(()=>{
                throw new Error(message);
            })),
    sequenceStruct: (0,fp_ts_lib_Apply__WEBPACK_IMPORTED_MODULE_7__.sequenceS)(fp_ts_lib_Option__WEBPACK_IMPORTED_MODULE_2__.Apply),
    unwrap: (o)=>(0,fp_ts_lib_function__WEBPACK_IMPORTED_MODULE_6__.pipe)(o, OAlt.expect("unwrap on none"))
};


/***/ }),

/***/ 11331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useAdminToken; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useAdminToken = ()=>{
    const [adminToken, setAdminToken] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (false) {}
        const urlSearchParams = new URLSearchParams(window.location.search);
        const adminToken = urlSearchParams.get("admin-token");
        if (typeof adminToken !== "string" || adminToken.length === 0) {
            return undefined;
        }
        setAdminToken(adminToken);
    }, []);
    return adminToken;
};


/***/ }),

/***/ 56862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _feature_flags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58739);
/* harmony import */ var _components_Texts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90917);





const Text = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Texts__WEBPACK_IMPORTED_MODULE_3__/* .BaseText */ .k$, {
        font: "font-inter",
        color: "text-slateus-300",
        size: "text-xs",
        children: children
    });
};
const HoverTooltip = (param)=>{
    let { align ="right" , children , customAlign , position ="bottom" , text , zLevel ="z-20"  } = param;
    const [showTooltip, setShowTooltip] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const featureFlags = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_feature_flags__WEBPACK_IMPORTED_MODULE_2__/* .FeatureFlagsContext */ .JN);
    if (text === undefined || !featureFlags.showTooltips) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative",
        onMouseOver: ()=>setShowTooltip(true),
        onMouseLeave: ()=>setShowTooltip(false),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "\n          absolute right-0 w-72\n          overflow-visible\n          rounded-lg border\n          border-slateus-400 bg-slateus-700\n          p-3 leading-4\n          ".concat(customAlign !== undefined ? customAlign : align === "right" ? "right-0" : "left-0", "\n          ").concat(position === "top" ? "bottom-8" : "top-8", "\n          ").concat(showTooltip ? "visible" : "hidden", "\n          ").concat(zLevel, "\n        "),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                    children: text
                })
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HoverTooltip);


/***/ }),

/***/ 62925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89802);
/* harmony import */ var _components_TimeFrameControl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5429);
/* harmony import */ var _dates__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71119);
/* harmony import */ var _duration__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5964);
/* harmony import */ var _time_frames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78868);








const getFormattedDays = (now, fork)=>{
    const daysCount = (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(now, fork);
    return "".concat(daysCount, "d");
};
const TimeFrameIndicator = (param)=>{
    let { className ="" , hideTimeFrameLabel , onClickTimeFrame , timeFrame  } = param;
    const [daysSinceLondon, setDaysSinceLondon] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [daysSinceMerge, setDaysSinceMerge] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setDaysSinceLondon(getFormattedDays(new Date(), _dates__WEBPACK_IMPORTED_MODULE_4__/* .londonHardFork */ .b9));
        setDaysSinceMerge(getFormattedDays(new Date(), _dates__WEBPACK_IMPORTED_MODULE_4__/* .mergeDateTime */ .s_));
        const id = setTimeout(()=>{
            setDaysSinceLondon(getFormattedDays(new Date(), _dates__WEBPACK_IMPORTED_MODULE_4__/* .londonHardFork */ .b9));
            setDaysSinceMerge(getFormattedDays(new Date(), _dates__WEBPACK_IMPORTED_MODULE_4__/* .mergeDateTime */ .s_));
        }, (0,_duration__WEBPACK_IMPORTED_MODULE_7__/* .millisFromHours */ .QN)(1));
        return ()=>clearTimeout(id);
    }, []);
    const ContainerElement = onClickTimeFrame === undefined ? "div" : "button";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TimeFrameControl__WEBPACK_IMPORTED_MODULE_3__/* .LondonHardForkTooltip */ .G, {
        zLevel: "z-30",
        timeFrame: timeFrame,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ContainerElement, {
            className: "\n          flex items-baseline gap-x-2\n          ".concat(onClickTimeFrame === undefined ? "" : "select-none hover:brightness-90 active:brightness-75", "\n          ").concat(className, "\n        "),
            onClick: onClickTimeFrame,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: hideTimeFrameLabel ? "hidden sm:block" : "block",
                    children: timeFrame === "since_burn" ? "since burn" : timeFrame === "since_merge" ? "since merge" : "time frame"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "font-roboto text-xs text-white",
                    children: timeFrame === "since_burn" ? daysSinceLondon : timeFrame === "since_merge" ? daysSinceMerge : _time_frames__WEBPACK_IMPORTED_MODULE_5__/* .displayLimitedTimeFrameMap */ .I1[timeFrame]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TimeFrameIndicator);


/***/ }),

/***/ 78868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EH": function() { return /* binding */ timeFramesNoMerge; },
/* harmony export */   "I1": function() { return /* binding */ displayLimitedTimeFrameMap; },
/* harmony export */   "YP": function() { return /* binding */ getNextTimeFrameNoMerge; },
/* harmony export */   "hN": function() { return /* binding */ timeFrames; },
/* harmony export */   "sC": function() { return /* binding */ toOldTimeFrame; },
/* harmony export */   "z9": function() { return /* binding */ getNextTimeFrame; }
/* harmony export */ });
/* unused harmony exports limitedTimeFrames, timeFramesOld, fromOldTimeFrame, getNextTimeFrameOld */
const limitedTimeFrames = [
    "m5",
    "h1",
    "d1",
    "d7",
    "d30"
];
/** @deprecated use timeFrames instead, with an API map to convert to/from legacy time frames. */ const timeFramesOld = (/* unused pure expression or super */ null && ([
    "m5",
    "h1",
    "d1",
    "d7",
    "d30",
    "all"
]));
const timeFramesNoMerge = [
    "m5",
    "h1",
    "d1",
    "d7",
    "d30",
    "since_burn"
];
const fromOldTimeFrame = (timeFrame)=>timeFrame === "all" ? "since_burn" : timeFrame;
const toOldTimeFrame = (timeFrame)=>timeFrame === "since_burn" ? "all" : timeFrame;
const displayLimitedTimeFrameMap = {
    m5: "5m",
    h1: "1h",
    d1: "1d",
    d7: "7d",
    d30: "30d"
};
const getNextTimeFrameOld = (timeFrame)=>{
    const nextIndex = (timeFramesOld.indexOf(timeFrame) + 1) % timeFramesOld.length;
    // Index is checked above.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return timeFramesOld[nextIndex];
};
const getNextTimeFrameNoMerge = (timeFrame)=>{
    const nextIndex = (timeFramesNoMerge.indexOf(timeFrame) + 1) % timeFramesNoMerge.length;
    // Index is checked above.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return timeFramesNoMerge[nextIndex];
};
// We care about the order here. since_merge first then since_burn, therefore
// we cannot extend the timeFramesNoMerge array.
const timeFrames = [
    ...limitedTimeFrames,
    "since_merge",
    "since_burn"
];
const getNextTimeFrame = (timeFrame)=>{
    const nextIndex = (timeFrames.indexOf(timeFrame) + 1) % timeFrames.length;
    // Index is checked above.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return timeFrames[nextIndex];
};


/***/ }),

/***/ 48613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sections_ContactSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/DefaultLink.tsx
var DefaultLink = __webpack_require__(39469);
;// CONCATENATED MODULE: ./src/components/DefaultTextLink.tsx


const DefaultTextLink = (param)=>/*#__PURE__*/ {
    let { children , className ="" , href , onMouseEnter , onMouseLeave  } = param;
    return (0,jsx_runtime.jsx)(DefaultLink/* default */.Z, {
        className: "\n      ".concat(href !== undefined ? "hover:underline" : "", "\n      ").concat(className, "\n    "),
        href: href,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        children: children
    });
};
/* harmony default export */ var components_DefaultTextLink = (DefaultTextLink);

// EXTERNAL MODULE: ./src/components/TextsNext/SectionTitle.tsx
var SectionTitle = __webpack_require__(44759);
;// CONCATENATED MODULE: ./src/components/SectionDivider.tsx


const SectionDivider = (param)=>/*#__PURE__*/ {
    let { link , title , subtitle  } = param;
    return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-16"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                link: link,
                subtitle: subtitle,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-16"
            })
        ]
    });
};
/* harmony default export */ var components_SectionDivider = (SectionDivider);

;// CONCATENATED MODULE: ./src/sections/ContactSection/email-slateus.svg
/* harmony default export */ var email_slateus = ({"src":"/_next/static/media/email-slateus.9d127915.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/assets/twitter-slateus.svg
/* harmony default export */ var twitter_slateus = ({"src":"/_next/static/media/twitter-slateus.d651d6ac.svg","height":100,"width":100});
;// CONCATENATED MODULE: ./src/sections/ContactSection/github-slateus.svg
/* harmony default export */ var github_slateus = ({"src":"/_next/static/media/github-slateus.3d2141cf.svg","height":100,"width":100});
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
;// CONCATENATED MODULE: ./src/sections/ContactSection/index.tsx







const Contact = (param)=>/*#__PURE__*/ {
    let { alt , imageSrc , href , children  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex w-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: alt,
                    src: imageSrc
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DefaultTextLink, {
                className: "flex items-center gap-x-2",
                href: href,
                children: children
            })
        ]
    });
};
const ContactSection = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex w-full flex-col items-center pb-40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SectionDivider, {
                title: "still have questions?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col justify-start gap-y-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact, {
                        alt: "twitter logo",
                        imageSrc: twitter_slateus,
                        href: "https://twitter.com/ultrasoundmoney",
                        children: "DM us @ultrasoundmoney"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact, {
                        alt: "icon of an envelope, symbolizing email",
                        imageSrc: email_slateus,
                        href: "mailto:contact@ultrasound.money",
                        children: "contact@ultrasound.money"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact, {
                        alt: "icon of GitHub, where the code for the site is hosted",
                        imageSrc: github_slateus,
                        href: "https://github.com/ultrasoundmoney/frontend",
                        children: "GitHub repo"
                    })
                ]
            })
        ]
    });
/* harmony default export */ var sections_ContactSection = (ContactSection);


/***/ }),

/***/ 69864:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"Accordion_item__FmWun","collapsed":"Accordion_collapsed__Qu3Fq","title":"Accordion_title__QDGNX","open":"Accordion_open__r__ky","emoji":"Accordion_emoji__83_wg","content":"Accordion_content__Qfqgr","mono":"Accordion_mono__8NnwZ","animateIn":"Accordion_animateIn__wwMZC","accordionIn":"Accordion_accordionIn__S1anB","normal":"Accordion_normal__a1jMQ","animateOut":"Accordion_animateOut__MlcZ4","accordionOut":"Accordion_accordionOut__wnOX4","wrapper":"Accordion_wrapper__vZ9ah"};

/***/ }),

/***/ 23375:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gradientText":"MainTitle_gradientText__taBaD"};

/***/ }),

/***/ 17743:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"toggle-switch":"ToggleSwitch_toggle-switch__lvdYh"};

/***/ }),

/***/ 23195:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"styled-scrollbar-vertical":"Scrollbar_styled-scrollbar-vertical__CXx8q","styled-scrollbar-horizontal":"Scrollbar_styled-scrollbar-horizontal___sKnh","styled-scrollbar":"Scrollbar_styled-scrollbar__VI2dY"};

/***/ })

}]);